import * as React from "react";
const SvgChevronLeft = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 12", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M7.9875 1L8.875 1.8875L4.7625 6L8.875 10.1125L7.9875 11L2.9875 6L7.9875 1Z" }));
export default SvgChevronLeft;
